// 银行活动相关 business
import { request } from '@tencent/ppd-base-libs';
import { handleFormatRes } from '@tencent/wphk-act-base-cgi';
import { batchArrStrToObj, getArrFromStr, getConfigWithLang } from '../../../utils';
import { ActivityType } from '../../../types/bank';
/** 获取分享链接 */
function getShareLinkByType(activityType) {
    if (activityType.includes(ActivityType.openAccActivity)) {
        return 'https://prom.wechatpay.com.hk/open-acc/index.shtml';
    }
    if (activityType.includes(ActivityType.bindCardAccActivity)) {
        return 'https://prom.wechatpay.com.hk/bind-card/index.shtml';
    }
}
/**
 * 拉取配置
 * @returns
 */
export async function getActConfig(business) {
    // 设置缓存
    localStorage.setItem('fbusiness', business);
    // 请求配置
    const url = `https://st.moneydata.hk/res/cc/bankActConfig/${business}.json`;
    const config = await request.loadVtools(url);
    return formatConfig(config);
}
/**
 * 格式化配置
 * @param config
 * @returns
 */
function formatConfig(config) {
    // ----1. 批量将字符串数组转成对象----
    const arrStrList = [
        /** 页面标题 */
        'pageTitle',
        /** 微信分享 */
        'shareInfo',
        /** 头图信息 */
        'headerInfo',
        /** 活动描述 */
        'activityDescInfo',
        /** 标题 */
        'titleInfo',
        /** 开户活动 */
        'stepInfo',
        /** 去绑卡信息 */
        'bankBankCard',
        /** 数量限制 */
        'broughtUp',
        /** 开户按钮 */
        'btnTextInfo',
        /** 绑定活动-动态按钮 */
        'dynamicButton',
    ];
    let strToArrConf = batchArrStrToObj({ config, configKey: arrStrList });
    strToArrConf = Object.assign(Object.assign({}, strToArrConf), { extra: formatExtra(getArrFromStr(strToArrConf.extra)) });
    // ----2. 活动类型兼容----
    const activityType = strToArrConf.activityType.split(',');
    // 开户活动
    if (activityType.includes(ActivityType.openAccActivity)) {
        strToArrConf.openAccActivity = Object.assign(Object.assign({}, strToArrConf.openAccActivity), { descInfo: getArrFromStr(strToArrConf.openAccActivity.descInfo), prizeDialogDescInfo: getArrFromStr(strToArrConf.openAccActivity.prizeDialogDescInfo) });
    }
    // 绑定活动
    if (activityType.includes(ActivityType.bindCardAccActivity)) {
        strToArrConf.bindCardAccActivity = Object.assign(Object.assign({}, strToArrConf.bindCardAccActivity), { descInfo: getArrFromStr(strToArrConf.bindCardAccActivity.descInfo) });
    }
    // ----2. 类型转换 转config格式：date,int----
    const needParseIntKey = [
        /** 头图高度 */
        'headerHeight',
        /** 头图高度英文 */
        'headerHeightEn',
        /** 宽度左侧距离 */
        'barLeft',
        /** 宽度 */
        'barWidth',
    ];
    // const needParseDateKey = [];
    const needParseBoolKey = [
        /** 开户活动-是否展示获得奖励弹窗 */
        'isShowPrizeDialog',
        /** 开户活动-是否展示数量限制 */
        'isShowBroughtUp',
        /** 开户活动-是否开启数量限制 */
        'isBroughtUp',
        /** 开户活动-是否展示去绑卡 */
        'isShowBankBankCard',
        /** 绑定活动-是否展示查看我的优惠券 */
        'isShowViewMyCoupon',
    ];
    const typeConf = handleFormatRes({
        result: strToArrConf,
        // needParseDateKey,
        needParseIntKey,
        needParseBoolKey,
    });
    // ----3. 多语言转换----
    if (!typeConf.headerInfo.headerHeightEn) {
        typeConf.headerInfo.headerHeightEn = typeConf.headerInfo.headerHeight;
    }
    const configKey = [
        // 页面标题,微信分享标题,开户活动(标题、绑卡标题)
        'title',
        // 微信分享描述
        'desc',
        // 头图链接
        'headerImgUrl',
        // 活动描述
        'activityDesc',
        // 开户活动描述值，奖励弹窗描述值
        'value',
        // 开户活动步骤
        'stepOne',
        'stepTwo',
        // 头图高度
        'headerHeight',
        // 开户按钮文案
        'btnText',
        // 扩展字段图片
        'image',
        'adTitleAdImg',
    ];
    const langConf = getConfigWithLang({ originalObj: typeConf, configKey });
    // ----4. 业务个别字段格式化----
    const ret = Object.assign(Object.assign({}, langConf), { pageTitle: langConf.pageTitle.title, activityType: langConf.activityType.split(',') });
    // 格式化微信分享
    if (ret.shareInfo) {
        ret.shareInfo = Object.assign(Object.assign({}, ret.shareInfo), { link: `${getShareLinkByType(activityType)}?business=${ret.business}&ADTAG=share` });
    }
    return ret;
}
/** 格式化扩展参数 */
const formatExtra = (extra = []) => {
    const obj = {};
    for (const iterator of extra) {
        obj[iterator.extraKey] = iterator.extraValue;
    }
    return obj;
};
